export default "__VITE_ASSET__BViT94xZ__"